export interface PageType { kind: string }

export const showOnHome = (page: PageType): boolean => page.kind == 'home'

export const showOnHomeAndBranch = (page: PageType): boolean => page.kind == 'home' || page.kind == 'locationDetail'

const homeAndActivities = new Set<string>(['home', 'activityClusters', 'activityDetail'])
export const showOnHomeAndActivities = (page) => homeAndActivities.has(page.kind)
